// Shared by the headers and rows so they stay aligned; stream columns split the rest.
export const COLUMN_WIDTHS = {
  patient: 250,
  appMode: 100,
  startDate: 116,
  createdAt: 116,
  lastContact: 110,
  medication: 150
} as const;

// Fits the widest header ("MOBILITY", "TAP TEST"). Below this the list scrolls sideways instead
// of squeezing the stream columns, eg while the patient sidebar is open (the table's min-content
// width comes from these and the fixed columns).
export const STREAM_MIN_WIDTH = 88;
